import React from "react";
import { shape, string, array, bool, object } from "prop-types";
import ArrowLink from "../ArrowLink/ArrowLink.jsx";
import SocialConnectIcons from "../SocialConnectIcons/SocialConnectIcons.jsx";

const propTypes = {
  image: shape({
    alt: string,
    sources: array,
  }),
  name: string.isRequired,
  occupation: string,
  description: string,
  cta: shape({
    href: string.isRequired,
    text: string,
  }),
  relatedContent: shape({
    href: string.isRequired,
    text: string.isRequired,
  }),
  fullWidth: bool,
  socialConnectIcons: object,
};

const ExpertProfileCard = (props) => {
  const {
    image,
    name,
    occupation,
    description,
    cta,
    relatedContent,
    fullWidth,
    socialConnectIcons,
  } = props;

  return (
    <section
      className={`expert-profile-card ${
        fullWidth ? "expert-profile-card--full-width" : ""
      }`}
    >
      {image && image.sources.length > 0 && (
        <figure className="expert-profile-card__media">
          {cta && cta.href ? (
            <a href={cta.href} title={name}>
              <img srcSet={image.sources.join(", ")} alt={image.alt} />
            </a>
          ) : (
            <img srcSet={image.sources.join(", ")} alt={image.alt} />
          )}
        </figure>
      )}
      <div className="expert-profile-card__expert-details">
        <div className="expert-profile-card__name">
          {cta && cta.href ? (
            <a className="link" href={cta.href}>
              {name}
            </a>
          ) : (
            name
          )}
        </div>
        {occupation && (
          <div className="expert-profile-card__occupation">{occupation}</div>
        )}
        {socialConnectIcons && (
          <div className="expert-profile-card__social">
            <SocialConnectIcons {...socialConnectIcons} />
          </div>
        )}
        {description && (
          <div
            className="expert-profile-card__description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        {cta && cta.text && (
          <div className="expert-profile-card__cta">
            <ArrowLink
              type={cta.type || ""}
              href={cta.href}
              text={"View Profile"}
            />
          </div>
        )}
        {relatedContent && (
          <div className="expert-profile-card__related-content">
            <a className="link" href={relatedContent.href}>
              {relatedContent.text}
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

ExpertProfileCard.propTypes = propTypes;
export default ExpertProfileCard;
